const timezones = {
    default: 'UTC',
};


export default timezones;
